import { authTypes } from '../auth/types'
import { ContractorItem } from '../types'
import { ContractorsActions, ContractorsType, contractorsTypes } from './types'

const initialState: ContractorsType = {
  allItems: [],
  items: [],
  start: 0,
  limit: 50,
  total: 0,
  contractor: null,
}
const reducer = (
  state = initialState,
  action: ContractorsActions
): ContractorsType => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: {
      return initialState
    }
    case authTypes.LOGOUT_REQUEST: {
      return initialState
    }

    case contractorsTypes.SET_CONTRACTOR: {
      return {
        ...state,
        contractor: payload
      } as ContractorsType
    }

    case contractorsTypes.SET_CONTRACTORS: {
      return {
        ...state,
        ...payload as ContractorsType
      } as ContractorsType
    }

    case contractorsTypes.SET_ALL_CONTRACTORS: {
      return {
        ...state,
        allItems: payload as ContractorItem[],
        total: (payload as ContractorItem[])?.length || 0
      }
    }

    default:
      return state
  }
}

export default reducer
